
async function addVariantAvailablility() {
	console.log("city from alpine store", Alpine.store('location').city);
	const variants = document.querySelectorAll('.quick-add[data-available=""]');
	const location = Alpine.store('location').city;
	
	if (variants.length > 0) {
		const variantsElArr = Array.from(variants);
		const variantsArr = variantsElArr.map(variant => {
			return parseInt(variant.getAttribute('data-variant-id'));
		});

		await fetch(`https://mednow-inventory.herokuapp.com/all-variants/?variants=${JSON.stringify(variantsArr)}&location=${location}`)
		.then((response) => response.json())
		.then((data) => {
			// const available = data.node.available;
			// variant.setAttribute('data-available', available);
			// variant.querySelector('button').disabled = false;
			// return { data, variant };
			console.log("bulk req => ", data);
			data.forEach(vr => {
				const els = document.querySelectorAll(`[data-variant-id="${vr.variant}"]`);
				els.forEach(el => {
					el.setAttribute('data-available', vr.quantity);
				})
			})
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {

	var endlessScroll = new Ajaxinate({
		container: "#product-grid",
		pagination: "#AjaxinatePagination",
		offset: 2000,
		method: "scroll",
		callback: (data) => {
			addVariantAvailablility();
		}
	});

  // if there is less products to activate the infinite scroll
	addVariantAvailablility();
  // const ajaxinatePagination = document.querySelector("#AjaxinatePagination");
  // if (!ajaxinatePagination.dataset.hasPagination) {
  // }
});